<template>
  <a-card class="h-full overflow-y-auto b-none" ref="divRef">
    <div class="w-full h-full relative z-10">
      <slot></slot>
    </div>
  </a-card>
</template>
<script setup lang="ts">
const divRef = ref();
const height = defineModel<number>("height");
const { height: boxHeight } = useElementSize(divRef);
watch(
  () => boxHeight.value,
  val => {
    height.value = val;
  }
);
</script>
